import { useContext, useState } from 'react';
import { Table, Icon, Popup, Card, Button, Modal, Form, TextArea } from 'semantic-ui-react'
import UserContext from '../../contexts/UserContext';
import { SuccessToast, ErrorToast } from '../Toasters';
import api from '../../apis/api';
import { epochToString, epochToStringNoT } from '../EpochToString';

const CardDetail = ({ticket, callback}) => {

    const userContext = useContext(UserContext)

    const [modal, setModal] = useState(false)
    const [reason, setReason] = useState('')


    const sendApproval = (decision) => {
        let link = btoa(`${userContext.userInfo.username}|${ticket.id}`)
        let params = {link: link, decision: decision}
        if (decision === 'deny'){
            if(reason === ''){
                ErrorToast('Please input a reason')
                return
            }
            params.reason = reason
        }
        api.post('/requests/approval', {}, {params: params}).then(r => {
            SuccessToast('Request has been processed')
            callback()
            setModal(false)
        }).catch(err => {
            ErrorToast(err)
        })
    }

    return (
        <>
            <Card.Content>
            <Table definition>
                <Table.Body>
                    <Table.Row>
                        <Table.Cell>Requester:</Table.Cell>
                        <Table.Cell>{ticket.requester}</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>Status:</Table.Cell>
                        <Table.Cell>{ticket.status}</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>Submit Date:</Table.Cell>
                        <Table.Cell>{epochToStringNoT(ticket.submitdate)}</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>Name:</Table.Cell>
                        <Table.Cell>{ticket.name}</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>Sites:</Table.Cell>
                        <Table.Cell>{ticket.sites?ticket.sites.map(i => {
                            let s = userContext.userInfo.site_list.find(a => a.site === i)
                            if(s){return <div key={s.id}>{s.label}</div>}
                            return <></>
                        }):null}</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>Start Date:</Table.Cell>
                        <Table.Cell>{epochToStringNoT(ticket.startDate)}</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>End Date:</Table.Cell>
                        <Table.Cell>{epochToStringNoT(ticket.endDate)}</Table.Cell>
                    </Table.Row>
                    {ticket.type==='tca_rm'?
                    <Table.Row>
                        <Table.Cell>Machine ID:</Table.Cell>
                        <Table.Cell>{ticket.machineID}</Table.Cell>
                    </Table.Row>
                    :null}
                    {ticket.type==='change'?
                    <Table.Row>
                        <Table.Cell>Impact Level:</Table.Cell>
                        <Table.Cell>{ticket.impact}</Table.Cell>
                    </Table.Row>
                    :null}
                </Table.Body>
            </Table>
            </Card.Content>
            <Card.Content extra>
                <div className="ui two buttons">
                    <Button basic color='green' onClick={() => sendApproval('approve')}>Approve</Button>
                    <Button basic color='red' onClick={() => setModal(true) }>Deny</Button>
                </div>
            </Card.Content>
            <Modal
                open={modal}
                onClose={() => setModal(false)}
            >
                <Modal.Content>
                    Please submit a reason for denying this request
                    <Form onSubmit={() => sendApproval('deny')}>
                        <TextArea name="deny_reason" value={reason} onChange={(e, d) => setReason(d.value)} required/>
                        <Button type="submit">Submit</Button>
                    </Form>
                </Modal.Content>
            </Modal>
    </>
    )


}

export default CardDetail